var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "btn-group",
      class: { "is-invalid": _vm.layoutData.errorText != null },
      attrs: { "data-toggle": "buttons" }
    },
    [
      _vm._l(_vm.layoutData.options, function(option) {
        return [
          _c(
            "label",
            {
              staticClass: "btn btn-default input-xsmall",
              class: option.value == _vm.valueData ? "active" : "",
              staticStyle: { "padding-right": "12px !important" },
              on: {
                click: function($event) {
                  return _vm.onChange($event, option.value)
                }
              }
            },
            [
              _c("input", {
                staticClass: "toggle",
                attrs: { type: "radio" },
                domProps: {
                  value: option.value,
                  checked: option.value == _vm.valueData
                }
              }),
              _vm._v(_vm._s(option.label))
            ]
          )
        ]
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }